import { SefrKiloometrEnum } from 'Feature/Khodro/Common/Enums/SefrKiloometrEnum';
import { TaghvimSaleSakhtEnum } from 'Feature/Khodro/Common/Enums/TaghvimSaleSakhtEnum';

import IVehicleInfoDto from '../../../../Commands/Soddor/IVehicleInfoDto';

export const VehicleInfoInitialStateSodoor: IVehicleInfoDto = {
  moredEstefadehCoreId: '',
  tipCoreId: '',
  noePelakCoreId: '',
  taghvimSaleSakht: TaghvimSaleSakhtEnum.Shamsi,
  saleSakht: 0,
  sefrKiloometr: SefrKiloometrEnum.YES,
  tarikhTahvilKhodro: undefined,
  noeVasilehNaghleyeh: '',
  serialPelakCoreId: '',
  rangCoreId: '',
  keshvarSazandehCoreId: '',
  shomarehMotor: '',
  shomarehShasi: '',
  shomarehEntezami1: '',
  shomarehEntezami2: '',
  shomarehEntezami3: '',
  vin: '',
};
